import { createAction } from 'redux-actions';
import { destroy } from 'redux-form';
import get from 'lodash/get';
import UnitActions from '../actions';
import { isWizardFirstStep, isWizardLastStep } from './selectors';
import { getCommunityCoordinates } from '../../communities/selectors';

const types = {
  startCreateUnitWizard: 'startCreateUnitWizard',
  stopCreateUnitWizard: 'stopCreateUnitWizard',
  setCurrentUnitWizardStep: 'setCurrentUnitWizardStep',
  updateWizardUnit: 'updateWizardUnit',
  setCreateUnitCoordinates: 'setCreateUnitCoordinates'
};

const startCreateUnitWizardAction = createAction(types.startCreateUnitWizard);
const stopCreateUnitWizard = createAction(types.stopCreateUnitWizard);
const setCurrentUnitWizardStep = createAction(types.setCurrentUnitWizardStep);
const updateWizardUnit = createAction(types.updateWizardUnit);
const setCreateUnitCoordinates = createAction(types.setCreateUnitCoordinates);

const hasCoordinates = location =>
  location != null &&
  Number(location.latitude) !== 0 &&
  Number(location.longitude) !== 0;

/**
 * Opens the wizard with the community's latitude/longitude preloaded, so a new
 * unit starts at the community's location instead of (0, 0); the admin can still
 * move it (map click, street search or typed coordinates).
 */
const startCreateUnitWizard = () => {
  return (dispatch, getState) => {
    dispatch(startCreateUnitWizardAction());
    const communityLocation = getCommunityCoordinates(getState());
    if (hasCoordinates(communityLocation)) {
      dispatch(
        setCreateUnitCoordinates({
          latitude: Number(communityLocation.latitude),
          longitude: Number(communityLocation.longitude)
        })
      );
    }
  };
};

const backInUnitCreateWizard = () => {
  return (dispatch, getState) => {
    const currentStep = getState().units.createUnitWizard.step;
    if (isWizardFirstStep(getState())) {
      return; //no-op
    }
    if (currentStep === 'location') {
      dispatch(setCurrentUnitWizardStep('lotInformation'));
    }
  };
};

const nextInUnitCreateWizard = unit => {
  return (dispatch, getState) => {
    const currentStep = getState().units.createUnitWizard.step;
    if (currentStep == null) {
      return; //no-op
    }
    if (isWizardLastStep(getState())) {
      dispatch(stopCreateUnitWizard());
      return;
    }
    dispatch(updateWizardUnit(unit));
    if (currentStep === 'lotInformation') {
      dispatch(setCurrentUnitWizardStep('location'));
    }
    if (currentStep === 'location') {
      const unitLocation = get(
        getState(),
        'units.createUnitWizard.createUnit.location'
      );
      dispatch(
        UnitActions.createUnit({
          ...unit,
          location: unitLocation
        })
      )
        .then(() => {
          dispatch(setCurrentUnitWizardStep('unitCreationSuccess'));
          dispatch(destroy('createUnitForm'));
        })
        .catch(() => null);
    }
  };
};

/**
 * Used when the Unit closes the wizard without finishing.
 * That happens when closes the modal.
 */
const closeCreateUnitWizard = () => {
  return dispatch => {
    dispatch(destroy('createUnitForm'));
    dispatch(stopCreateUnitWizard());
  };
};

export { types };
export default {
  startCreateUnitWizard,
  closeCreateUnitWizard,
  nextInUnitCreateWizard,
  backInUnitCreateWizard,
  setCreateUnitCoordinates
};
